export default function PasoGuia({ children, id, tituloPaso, bloqueado}) {
  return (
    <>
    <div className="accordion-item">
      <h2 className="accordion-header" id={'heading-' + id}>
        <button
          className = "accordion-button fw-bold collapsed"
          type = "button"
          data-bs-toggle = "collapse"
          data-bs-target = {'#collapse-' + id}
          aria-expanded = "false"
          aria-controls = {'collapse-' + id}
          disabled = {bloqueado}
          >
          {tituloPaso}
          {bloqueado ? (<strong> *</strong>) : ""}
        </button>
      </h2>
      <div
        id={'collapse-' + id}
        className="accordion-collapse collapse"
        aria-labelledby={'heading-' + id}
        data-bs-parent="#pasosGuia"
      >
        <div className="accordion-body">{children}</div>
      </div>
    </div>
    </>
  );
}